export const scrollToTop = () => typeof window !== 'undefined' && window.scrollTo(0, 0);
export const compareArrays = (a1: any[], a2: any[]) =>
  a1?.length === a2?.length && a1?.every((v, i) => v === a2[i]);
export const findDuplicates = (arrs: any[][]) =>
  []
    .concat(...(arrs as never[]))
    .filter((e, idx, arr) => arr.indexOf(e) !== idx && arr.lastIndexOf(e) === idx);
